export const svraiProjectEmpty = {
    "uuid": "ab800e6f-60a7-4763-b80c-ca90b34f1f06",
    "createdAt": "2022-05-12T12:46:22.358000",
    "updatedAt": "2023-01-06T09:54:57.932000",
    "firstEventDate": null,
    "lastEventDate": null,
    "tags": [],
}